<template>
    <div class="container-fluid">
        <admin-header :name="$t('Special offers')" @create="newSpecialOffer" :add-new="addNewBtn"/>
        <app-card>
            <router-view name="specialoffers"/>
        </app-card>
    </div>
</template>

<script>
export default {
    computed: {
        addNewBtn() {
            return this.$route.fullPath == '/auth/special-offers' || this.$route.fullPath == '/auth/special-offers/';
        }
    },
    methods: {
        newSpecialOffer() {
            this.$router.push({name:'specialoffers.create'});
        }
    },
    metaInfo() {
        return {
            title: this.$t('Special offers')
        };
    }
};
</script>
